// // context/UserContext.js
// import React, { createContext, useContext, useState } from 'react';

// const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//   const [userId, setUserId] = useState(''); 

//   return (
//     <UserContext.Provider value={{ userId, setUserId }}>
//       {children}
//     </UserContext.Provider>
//   );
// };

// export const useUserContext = () => {
//   return useContext(UserContext);
// };
import React, { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState("");
  const [userRole, setUserRole] = useState(null);
  const [tenantId, setTenantId] = useState(null);
  const [tenantName, setTenantName] = useState("");
  const [selectedTenantId, setSelectedTenantId] = useState("");
  const [selectedTenantName, setSelectedTenantName] = useState("");

  // Initialize context values from sessionStorage on mount
  useEffect(() => {
    console.log("UserContext: Initializing from sessionStorage");
    
    const storedUserId = sessionStorage.getItem("userId");
    const storedRole = sessionStorage.getItem("userRole");
    const storedTenantId = sessionStorage.getItem("tenantId");
    const storedSelectedTenantId = sessionStorage.getItem("selectedTenantId");
    const storedSelectedTenantName = sessionStorage.getItem("selectedTenantName");
    
    if (storedUserId) {
      console.log("UserContext: Setting userId from sessionStorage", storedUserId);
      setUserId(storedUserId);
    }
    
    if (storedRole) {
      console.log("UserContext: Setting userRole from sessionStorage", storedRole);
      setUserRole(storedRole);
    }
    
    if (storedTenantId) {
      console.log("UserContext: Setting tenantId from sessionStorage", storedTenantId);
      setTenantId(storedTenantId);
    }
    
    if (storedSelectedTenantId) {
      console.log("UserContext: Setting selectedTenantId from sessionStorage", storedSelectedTenantId);
      setSelectedTenantId(storedSelectedTenantId);
    }
    
    if (storedSelectedTenantName) {
      console.log("UserContext: Setting selectedTenantName from sessionStorage", storedSelectedTenantName);
      setSelectedTenantName(storedSelectedTenantName);
    }
  }, []); // Empty dependency array - only run once on mount

  // Log context updates for debugging
  useEffect(() => {
    console.log("UserContext: userId updated", userId);
  }, [userId]);

  useEffect(() => {
    console.log("UserContext: userRole updated", userRole);
  }, [userRole]);

  useEffect(() => {
    console.log("UserContext: tenantId updated", tenantId);
  }, [tenantId]);

  useEffect(() => {
    console.log("UserContext: selectedTenantId updated", selectedTenantId);
  }, [selectedTenantId]);

  // Function to refresh context from sessionStorage
  const refreshContext = () => {
    console.log("UserContext: Refreshing from sessionStorage");
    
    const storedUserId = sessionStorage.getItem("userId");
    const storedRole = sessionStorage.getItem("userRole");
    const storedTenantId = sessionStorage.getItem("tenantId");
    const storedSelectedTenantId = sessionStorage.getItem("selectedTenantId");
    const storedSelectedTenantName = sessionStorage.getItem("selectedTenantName");
    
    if (storedUserId !== userId) setUserId(storedUserId || "");
    if (storedRole !== userRole) setUserRole(storedRole || null);
    if (storedTenantId !== tenantId) setTenantId(storedTenantId || null);
    if (storedSelectedTenantId !== selectedTenantId) setSelectedTenantId(storedSelectedTenantId || "");
    if (storedSelectedTenantName !== selectedTenantName) setSelectedTenantName(storedSelectedTenantName || "");
  };

  // Function to handle logout and reset all context state
  const handleLogout = () => {
    setUserId("");
    setUserRole(null);
    setTenantId(null);
    setTenantName("");
    setSelectedTenantId("");
    setSelectedTenantName("");
  };

  return (
    <UserContext.Provider
      value={{
        userId,
        setUserId,
        userRole,
        setUserRole,
        tenantId,
        setTenantId,
        tenantName,
        setTenantName,
        selectedTenantId,
        setSelectedTenantId,
        selectedTenantName,
        setSelectedTenantName,
        refreshContext,
        handleLogout
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);

